import { createMutation } from "react-query-kit";
import type { MutationFunction } from "@tanstack/react-query";

import { axiosClient, queryClient } from "../../clients";

import type { IMemberLaboratories } from "./routeType";

import type { IPickDelete } from "@/api";
import { getApi } from "@api/apiPath";
import { useGetAllMemberLaboratories } from "@/api/members/laboratories/getAll";
import { useGetMemberLaboratory } from "@/api/members/laboratories/get";

const { getPath } = getApi("members.laboratories.delete");

type IExtractedRouteType = IMemberLaboratories["laboratorySingleDelete"];

export type IDeleteMemberLaboratory = IPickDelete<IExtractedRouteType>;

const deleteMemberLaboratory: MutationFunction<
  IDeleteMemberLaboratory["response"],
  IDeleteMemberLaboratory["variables"]
> = ({ labId }) => {
  return axiosClient.delete(getPath({ labId }));
};

export const useDeleteMemberLaboratory = createMutation({
  mutationFn: deleteMemberLaboratory,
  onSuccess: (_, { labId }) => {
    queryClient.invalidateQueries({
      queryKey: useGetAllMemberLaboratories.getKey(),
    });
    queryClient.invalidateQueries({
      queryKey: useGetMemberLaboratory.getKey({ labId }),
    });
  },
});
